// Dashboard module page-level translations
export default {
    'workplace.greeting.midnight': 'Good Night',
    'workplace.greeting.earlyMorning': 'Good Morning',
    'workplace.greeting.noon': 'Good Noon',
    'workplace.greeting.afternoon': 'Good Afternoon',
    'workplace.greeting.evening': 'Good Evening',
    'workplace.date.sunday': 'Sunday',
    'workplace.date.monday': 'Monday',
    'workplace.date.tuesday': 'Tuesday',
    'workplace.date.wednesday': 'Wednesday',
    'workplace.date.thursday': 'Thursday',
    'workplace.date.friday': 'Friday',
    'workplace.date.saturday': 'Saturday',
    'workplace.date.format': '{year}/{month}/{day}',
    
    'workplace.stat.availableApps': 'Available Apps',
    'workplace.stat.tokenConsumption': 'Token Consumption',
    
    'workplace.recentApps.title': 'Frequent Apps',
    'workplace.recentApps.viewAll': 'View All',
    'workplace.recentApps.empty.description': 'No recently visited apps, ',
    'workplace.recentApps.empty.link': 'Explore',
    'workplace.recentApps.noDescription': 'No description',
    
    'workplace.quickNav.title': 'Quick Navigation',
    'workplace.quickNav.add': 'Add',
    'workplace.quickNav.edit': 'Edit Quick Navigation',
    'workplace.quickNav.addNew': 'Add Quick Navigation',
    'workplace.quickNav.modal.title': 'Title',
    'workplace.quickNav.modal.titlePlaceholder': 'Please enter title',
    'workplace.quickNav.modal.link': 'Link',
    'workplace.quickNav.modal.linkRequired': 'Please select or enter a link',
    'workplace.quickNav.modal.menuTab': 'Select Menu',
    'workplace.quickNav.modal.customTab': 'Custom Link',
    'workplace.quickNav.modal.menuPlaceholder': 'Please select a menu',
    'workplace.quickNav.modal.customPlaceholder': 'Please enter custom link, e.g. /dashboard/workplace',
    'workplace.quickNav.deleteConfirm.title': 'Confirm Delete',
    'workplace.quickNav.deleteConfirm.content': 'Are you sure you want to delete this quick navigation?',
    'workplace.quickNav.deleteSuccess': 'Deleted successfully',
    'workplace.quickNav.editSuccess': 'Modified successfully',
    'workplace.quickNav.addSuccess': 'Added successfully',
    
    'workplace.accessibleModules.title': 'Accessible Modules',
    
    'workplace.profile.company': 'Company',
    'workplace.profile.department': 'Department',
    'workplace.profile.email': 'Email',

      // 新增的 nav 相关键名
  'workplace.nav.edit': 'Edit',
  'workplace.nav.delete': 'Delete',
  'workplace.nav.add': 'Add',
  };
